import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../redux/store.model';
import { getHierarchy } from '../../redux/structure/selectors/Level.selector';

function useHierarchy() {
  const { marketId } = useParams<{ marketId: string }>();
  const hierarchy = useAppSelector((state) =>
    getHierarchy(state, { workspaceId: marketId })
  );
  return hierarchy;
}

export default useHierarchy;
